import style from "./NewCommentHeader.module.css";

interface CommentHeaderProps {
  title: string;
  actions?: React.ReactNode;
}

export const NewCommentHeader = ({ title, actions }: CommentHeaderProps) => {
  return (
    <div className={style.header}>
      <div className={style.info}>
        <div className={style.title}>{title}</div>
      </div>
      <div className={style.actions}>{actions}</div>
    </div>
  );
};
